export default __webpack_public_path__ + "static/media/pbm_builders.abb84c8c.png";